import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vuetify from 'vuetify';
import colors from 'vuetify/es5/util/colors';
import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
import VueQriously from 'vue-qriously';
import VueQrcodeReader from 'vue-qrcode-reader';
Vue.use(Vuetify, {
    theme: {
        original: colors.purple.base,
        theme: '#FFDEEA',
        background: '#FFF6EA',
        view: '#ffa07a',
        select: '#FF7F78',
        button: '#5FACEF'
    },
    options: {
        themeVariations: ['original', 'secondary']
    }
});
Vue.use(Toast, {
    defaultType: 'bottom',
    duration: 3000,
    wordWrap: true,
    width: '280px'
});
Vue.use(VueQriously);
Vue.use(VueQrcodeReader);
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router: router,
    template: '<App/>',
    components: { App: App }
});



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = 275
// module chunks = 1